var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect } from "react";
import { TabbedShowLayout, useRecordContext } from "react-admin";
import ElectionHeader from "../../components/ElectionHeader";
import { EditCandidateData } from "./EditCandidateData";
import { useElectionEventTallyStore } from "@/providers/ElectionEventTallyProvider";
export var CandidateTabs = function () {
    var record = useRecordContext();
    var _a = useElectionEventTallyStore(), setCandidateIdFlag = _a.setCandidateIdFlag, setContestIdFlag = _a.setContestIdFlag, setElectionEventIdFlag = _a.setElectionEventIdFlag;
    useEffect(function () {
        if (record) {
            setCandidateIdFlag(record.id);
            setContestIdFlag(record.contest_id);
            setElectionEventIdFlag(record.election_event_id);
        }
    }, [record]);
    return (_jsxs(_Fragment, { children: [_jsx(ElectionHeader, { title: (record === null || record === void 0 ? void 0 : record.name) || "", subtitle: "candidateScreen.common.subtitle" }), _jsx(TabbedShowLayout, { children: _jsx(TabbedShowLayout.Tab, __assign({ label: "Data" }, { children: _jsx(EditCandidateData, { record: record }) })) })] }));
};
